import { Button, Box } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import { closeModal } from '../../../store/reducers/modal/modal.slice'
import { useDispatch } from 'react-redux'

interface ConfirmOrderModalProps {
  onConfirm: () => void
  onCancel?: () => void
  content?: React.ReactNode
}

const ConfirmOrderModal = ({
  onConfirm,
  onCancel,
  content,
}: ConfirmOrderModalProps) => {
  const dispatch = useDispatch()

  return (
    <>
      {content}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1,
          mt: 2,
        }}
      >
        <Button
          startIcon={<ClearIcon />}
          color="inherit"
          onClick={() => {
            if (onCancel) {
              onCancel()
            }
            dispatch(closeModal())
          }}
          size="large"
          variant="contained"
        >
          ยกเลิก
        </Button>
        <Button
          startIcon={<SaveIcon />}
          color="primary"
          onClick={onConfirm}
          size="large"
          variant="contained"
        >
          ยืนยัน
        </Button>
      </Box>
    </>
  )
}

export default ConfirmOrderModal
